import cx from "classnames";
import React, { ReactNode } from "react";

import { Icon } from "@/components/elements/Icon";
import { Text } from "@/components/elements/Text";

import styles from "./styles.module.css";

/*
  VERSIONS 
  - standard: has bg that expands when open (eg FAQ)
  - list: border top and bottom with small arrows (eg product info)
  - mini: bg always with small arrows
*/
export type AccordionVersions = "standard" | "list" | "mini";

export type AccordionProps = {
  title: string | ReactNode;
  version?: AccordionVersions;
  forceOpen?: boolean;
  startOpen?: boolean;
  className?: string;
  children: ReactNode;
};

export const Accordion = ({
  title,
  version = "standard",
  forceOpen,
  startOpen,
  className,
  children,
}: AccordionProps) => {
  const iconType =
    version === "mini" || version === "list" ? "chevron_down" : "arrow_down";
  const iconSize = iconType === "arrow_down" ? "md" : "sm";
  const icon = (
    <span className={styles.summaryArrow}>
      <Icon type={iconType} size={iconSize} />
    </span>
  );
  const Root = forceOpen ? "div" : "details";
  const RootInner = forceOpen ? "div" : "summary";
  return (
    <Root
      className={cx(
        styles.container,
        styles[version],
        { [styles.forceOpen]: forceOpen },
        className
      )}
      open={startOpen}
    >
      {typeof title === "string" ? (
        <RootInner className={styles.summary}>
          <Text as="div" responsive className={styles.summaryInner}>
            <span style={{ maxWidth: "85%" }}>{title}</span>
            {icon}
          </Text>
        </RootInner>
      ) : (
        <RootInner className={styles.summary}>
          {title}
          {icon}
        </RootInner>
      )}
      {children}
    </Root>
  );
};
